import React, { useEffect, useState } from 'react';
import {  DropDown } from '../../commons';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import {
  CalenderIcon,
  CreditArrow,
  DebitArrow,
} from '../../Icon';
import './OtherEntry.scss';
import { AllLedgersListType } from '../../../redux/clientSettings/clientSettingTypes';
import {
  Input,
} from 'reactstrap';
import { ItemTypes, OtherErrorType, TRANSACTION_TYPES } from '../../../screens/InvoiceGeneration/AddEditOtherEntryInvoice';
import CustomerSupplierModal from '../CustomerSupplierModal';
import { useMenuCheck } from '../../../customHooks/useMenuCheck';
import { AllocationIcon, RedDeleteIcon } from '../../../assets/images';
import { GetAllocationPayloadType } from '../../../commonTypes/invoiceGenerationTypes';
import { OverlayTrigger,Tooltip } from 'react-bootstrap';
import { components } from 'react-select';


type FinalLedgerListType = {
  value: AllLedgersListType,
  label: string;
}



type AppProps = {
  handleNarrationInBankChange: (e: any) => void;
  handleDateOfInvoiceChange: (e: any) => void;
  narrationInBank: string;
  dateOfInvoice: string;
  allLedgersList: [] | AllLedgersListType[];
  itemData: ItemTypes[];
  handleChange: (dataKey: any, value: any, index: number) => void;
  handleRemoveRow: (i: number, index: any, dataKey: string) => void;
  totalAmount: number;
  otherErrors: OtherErrorType;
  client_code?: number | undefined;
  branch: any;
  option: any;
  isEdit:boolean;
  formType?:string | undefined;
  token:string | null;
  handleChangeBranchName: (data: any) => void;
  handleKeyPress?:(data:any)=>void;
  // setupdate:boolean;
  auditSeasonMessage?:string
  currencySign: string | undefined;
  toggleAllocationModal?:()=>void;
  handleGetAllocationData?:(data:GetAllocationPayloadType,othersPaymentId:number,fullData:any)=>void;
  setAllocatedAmount?:(data:number)=>void;
  setPersistAllocatedAmount?:(data:number)=>void;
  resetAllocationList?:()=>void;
}

const OtherEntryForm = ({
  handleNarrationInBankChange,
  handleDateOfInvoiceChange,
  handleRemoveRow,
  narrationInBank,
  client_code,
  otherErrors,
  dateOfInvoice,
  allLedgersList,
  handleChange,
  itemData,
  branch,
  option,
  handleChangeBranchName,
  handleKeyPress,
  auditSeasonMessage,
  currencySign,
  token,
  isEdit,
  formType,
  toggleAllocationModal,
  handleGetAllocationData,
  setAllocatedAmount,
  setPersistAllocatedAmount,
  resetAllocationList
}: AppProps) => {

  const [finalLedgerList, setFinalLedgerList] = useState<FinalLedgerListType[] | []>([]);
  const { dateOfInvoiceError } = otherErrors;
  const [showAddCustomerSupplierModal, setShowAddCustomerSupplierModal] = useState<boolean>(false);
  const [isAddCustomerSupplierPresent, setIsAddCustomerSupplierPresent] = useMenuCheck();
 

  const type = 'other entries'
  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props} >
        <div className='d-flex justify-content-sm-start' style={{ gap: '10px' }}>
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>{data?.label}</span>
            <br></br>
            <span style={{ color: "#6e7491" }}>{data?.value?.trade_name}</span>
          </div>
        </div>
      </components.Option>
    );
  };

  useEffect(() => {
    setIsAddCustomerSupplierPresent("Add Customer/Supplier", "menu")
    const ledgerList: any = [];
    if (allLedgersList) {
      allLedgersList.map((ledger: AllLedgersListType) => {
        ledgerList.push({
          value: ledger,
          label: `${ledger?.ledger_name} (${ledger?.ledger_number})`
        })
      })
    }

    setFinalLedgerList(ledgerList)
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [allLedgersList]);

  const handleToggleAddCustomerSupplierModal = () => {
    setShowAddCustomerSupplierModal(!showAddCustomerSupplierModal);
  };

  const handleAllocationModalClick=(data:any,id:number)=>{
    resetAllocationList && resetAllocationList()
      if(id){
        setAllocatedAmount && setAllocatedAmount(data?.amount)
        setPersistAllocatedAmount && setPersistAllocatedAmount(data?.amount)
      }



    let finalData:GetAllocationPayloadType={
      client_code,
      id:data?.account_details?.value?.ledger_id,
      type:data?.transaction_type?.value == "credit" ? "revenues" : "expenses",
      token
    }
    handleGetAllocationData && handleGetAllocationData(finalData,id,data)

    toggleAllocationModal && toggleAllocationModal()
  }



  const renderItems = () => {

    let arr: any[] = []

    itemData && itemData.map((item: any, i: number) => {

      if (item.hasOwnProperty('transaction_type')) {
        arr.push(
          <div className="col-md-3 mt-2 mb-2">
            <DropDown
              placeholder="Choose Transaction Type..."
              options={TRANSACTION_TYPES}
              handleChange={(option) => handleChange('transaction_type', option, i)}
              value={item['transaction_type'] ? item['transaction_type'] : 'Choose Transaction Type...'}
            />
          </div>
        )
      }

      if (item.hasOwnProperty('account_details')) {
        arr.push(
          <div className="col-md-5 mt-2 mb-2">
            <DropDown
              placeholder="Choose Account..."
              options={finalLedgerList}
              handleChange={(option) => handleChange('account_details', option, i)}
              components={{ Option }}
              value={item['account_details'].value ? item['account_details'] : 'Choose Account...'}
            />
          </div>
        )
      }

      if (item.hasOwnProperty('amount')) {
        arr.push(<>
          <div className="col-md-3 mt-2 mb-2 position-relative">
            <Input
              type='number'
              style={{ paddingLeft:`${currencySign?.length&&currencySign?.length>1?((currencySign?.length*10)+10):17}px`}}
              value={item['amount'] || ''}
              maxLength={100}
              onChange={(e) => handleChange('amount', e.target.value, i)}
              disabled={!item?.transaction_type?.value}
              onWheel={event => event.currentTarget.blur()}
            />
            <div style={{ position: 'absolute', left: '22px', top: '8px' }}>
              {currencySign}
            </div>
            {Object.keys(item?.transaction_type)?.length ? <div style={{ position: 'absolute', top: '7px', right: '30px' }}>
              {item['transaction_type'] && item['transaction_type'].value === 'debit' ? <DebitArrow /> : <CreditArrow />}
            </div> : null}
          </div>
          <div  className="col-md-0.5 mt-3 pointer">
            {itemData.length > 1 ? <span className='others-entry-icons' onClick={() => handleRemoveRow(i, item, item?.transaction_type?.value)}>
              <img src={RedDeleteIcon} alt='delete'/>
            </span> : null}
          </div>

          <div  className="col-md-0.5 mt-3 ml-1 pointer">
          { isEdit && +item?.account_details?.value?.ledger_type_id===2 && formType!="duplicateInvoice" && 
          
          <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 250 }}
                  overlay={
                    <Tooltip id="button-view">
                      {"Allocate Amount"}
                    </Tooltip>
                  }
                >
                 <span className='others-entry-icons' onClick={()=>{
            handleAllocationModalClick(item,i+1)}}>
            <img src={AllocationIcon} alt='allocation'/>  
            </span>
                </OverlayTrigger>
         }
          </div>
        </>)
      }
    })
    return arr;
  }

  return (
    <>
      <div className="row">
        <div className="col-md-4">
          <div className="form-group">
            <label>Branch <span className='text-danger'>*</span></label>
            <DropDown
              placeholder="Choose branch name..."
              options={option}
              handleChange={handleChangeBranchName}
              value={branch}
            />
            <small className="text-danger">{otherErrors?.branchError}</small>
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group">
            <label>Date <span className='text-danger'>*</span></label>
            <div className='date-picker-wraper mr-0'
            // Future Use
            //  style={{border:auditSeasonMessage?"1px solid #F3A119":"",borderRadius:"4px"}}
             >
              <DatePicker
                dateFormat="dd-MM-yyyy"
                selected={dateOfInvoice ? new Date(moment(`${dateOfInvoice}T00:00:00`, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss')) : null}
                onChange={(e: any) => { handleDateOfInvoiceChange(moment(e).format('YYYY-MM-DD')) }}
                fixedHeight
                showMonthDropdown
                showYearDropdown
                name='dateOfInvoice'
                className={`form-control ${!!dateOfInvoiceError ? 'error-border' : null}`}
              />
              <span className="calender-icon" style={{ right: '28px', top: '30px' }}>
                <CalenderIcon />
              </span>
            </div>
            {/* Future Use */}
             {/* {<small  style={{position:"absolute",color:"#DD9215",}}>
                        {auditSeasonMessage?auditSeasonMessage:""}
                    </small>} */}
            {!!dateOfInvoiceError && <small className="text-danger">{dateOfInvoiceError}</small>}
          </div>
        </div>
      </div>
      <div className='row'>
        <div className="col-md-8">
          <form>
            <div className="form-group">
              <div style={{ width: '100%' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <label htmlFor="Narration in Bank"
                    className={narrationInBank ? "active" : ""}
                  >Narration in Bank Statement</label>

                  {isAddCustomerSupplierPresent && <small className='text-danger pointer'
                    style={{
                      marginTop: '6px',
                      fontSize: '12px'
                    }}
                    onClick={handleToggleAddCustomerSupplierModal}
                  >
                    {`+ Add Customer/Supplier (if not in list)`}
                  </small>}
                </div>
                <input
                  type="text"
                  className={`form-control`}
                  name="narrationInBank"
                  value={narrationInBank}
                  onChange={(e) => handleNarrationInBankChange(e)}
                  onKeyDown={(e)=> handleKeyPress && handleKeyPress(e)}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="row ">
        <div className="header-background" style={{ marginLeft: "15px", width: '89%' }}>
          <div className="col-md-3">Sent/Received*</div>
          <div className="col-md-5" style={{ marginLeft: '1.5%' }}>Select Account*</div>
          <div className="col-md-3" style={{ marginLeft: '4%' }}>Amount*</div>
        </div>
      </div>
      <div className="row">
        {renderItems()}
      </div>
      {showAddCustomerSupplierModal && <CustomerSupplierModal
        modal={showAddCustomerSupplierModal}
        toggleModal={handleToggleAddCustomerSupplierModal}
        client_code={client_code}
        type={type}
      />}
    </>
  )
};

export default OtherEntryForm;
